import { useCallback, useEffect, useMemo, useState } from "react";
import { createInitialPriceFilter } from "./usePriceFilterInSearchFilters";

function buildSearchFiltersAfterRemovingTag({
  previousFilters,
  tagToRemove,
  prefectureNameByIdMap,
}) {
  if (tagToRemove.type === "role") {
    const nextRoleIds = previousFilters.roleIds.filter(
      (roleId) => String(roleId) !== String(tagToRemove.value)
    );
    return { ...previousFilters, roleIds: nextRoleIds };
  }

  if (tagToRemove.type === "prefecture") {
    const nextPrefectureIds = previousFilters.prefectureIds.filter((prefectureId) => {
      const prefectureName = prefectureNameByIdMap.get(String(prefectureId));
      return prefectureName !== tagToRemove.value;
    });

    return { ...previousFilters, prefectureIds: nextPrefectureIds };
  }

  if (tagToRemove.type === "price") {
    return {
      ...previousFilters,
      priceFilter: createInitialPriceFilter(),
    };
  }

  return previousFilters;
}

export default function useRemoveFilterTagAndSearch({
  setSearchFilters,
  executeSearch,
  prefectures,
}) {

  const prefectureNameByIdMap = useMemo(() => {
    return new Map(prefectures.map((prefecture) => [String(prefecture.id), prefecture.name]));
  }, [prefectures]);

  const [pendingSearchFilters, setPendingSearchFilters] = useState(null);

  const handleRemoveFilterTagAndSearch = useCallback(
    (tagToRemove) => {
      setSearchFilters((previousFilters) => {
        const nextFilters = buildSearchFiltersAfterRemovingTag({
          previousFilters,
          tagToRemove,
          prefectureNameByIdMap,
        });

        setPendingSearchFilters(nextFilters);
        return nextFilters;
      });
    },
    [setSearchFilters, prefectureNameByIdMap]
  );

  useEffect(() => {
    if (!pendingSearchFilters) return;

    executeSearch(pendingSearchFilters);
    setPendingSearchFilters(null);
  }, [pendingSearchFilters, executeSearch]);

  return { handleRemoveFilterTagAndSearch };
}